var _title, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "48px",
    viewBox: "0 0 38 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon/editor/insert_drive_file_24px")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.6666667,4.66666667 L14,4.66666667 C11.4333333,4.66666667 9.35666667,6.76666667 9.35666667,9.33333333 L9.33333333,46.6666667 C9.33333333,49.2333333 11.41,51.3333333 13.9766667,51.3333333 L42,51.3333333 C44.5666667,51.3333333 46.6666667,49.2333333 46.6666667,46.6666667 L46.6666667,18.6666667 L32.6666667,4.66666667 Z M14,46.6666667 L14,9.33333333 L30.3333333,9.33333333 L30.3333333,21 L42,21 L42,46.6666667 L14,46.6666667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Message-Templates",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sf_WA_template_new_media",
    transform: "translate(-642.000000, -872.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tab_card",
    transform: "translate(262.000000, 635.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(16.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(16.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Visual-Picker-/-Coverable-Content-Copy-6",
    transform: "translate(300.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "State"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/editor/insert_drive_file_24px",
    transform: "translate(39.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6666667,4.66666667 L14,4.66666667 C11.4333333,4.66666667 9.35666667,6.76666667 9.35666667,9.33333333 L9.33333333,46.6666667 C9.33333333,49.2333333 11.41,51.3333333 13.9766667,51.3333333 L42,51.3333333 C44.5666667,51.3333333 46.6666667,49.2333333 46.6666667,46.6666667 L46.6666667,18.6666667 L32.6666667,4.66666667 Z M14,46.6666667 L14,9.33333333 L30.3333333,9.33333333 L30.3333333,21 L42,21 L42,46.6666667 L14,46.6666667 Z",
    fill: "#FFFFFF"
  })))))))))));
};
export default SvgFile;